import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { DataTableModule } from '../../data-table/data-table.module';
import { DataWidgetsModule } from '../rankings/data-widgets/data-widgets.module';
import { DetailsPageModule } from '../insights/details-page/details-page.module';
import { DirectivesModule } from 'app/directives/directives.module';
import { PipesModule } from '../../../pipes/pipes.module';
import { SharedModule } from '../../shared/shared.module';
import { TooltipModule } from '../../tooltip/tooltip.module';

import { DeveloperComplianceRiskAnalysisComponent } from './side-insight/developer-compliance-risk-analysis/developer-compliance-risk-analysis.component';
import { DeveloperIdentityComponent } from './side-insight/developer-identity/developer-identity.component';
import { DeveloperOverviewComponent } from './side-insight/developer-overview/developer-overview.component';
import { DeveloperTrafficQualityComponent } from './side-insight/developer-traffic-quality/developer-traffic-quality.component';
import { KnowYourDeveloperComponent } from './know-your-developer.component';
import { KydRouting, KydRoutingProviders } from './know-your-developer.routing';
import { SideInsightComponent } from './side-insight/side-insight.component';

@NgModule({
  declarations: [
    DeveloperComplianceRiskAnalysisComponent,
    DeveloperIdentityComponent,
    DeveloperOverviewComponent,
    DeveloperTrafficQualityComponent,
    KnowYourDeveloperComponent,
    SideInsightComponent
  ],
  imports: [
    CommonModule,
    DataTableModule,
    DataWidgetsModule,
    DetailsPageModule,
    DirectivesModule,
    FormsModule,
    PipesModule,
    SharedModule,
    TooltipModule,
    KydRouting
  ],
  exports: [],
  providers: [KydRoutingProviders]
})
export class KnowYourDeveloperModule {}
